import { createStore, combineReducers, applyMiddleware } from "redux";
import storage from "redux-persist/lib/storage";
import configReducer from "./configReducer";
import topicReducer from "./topicReducer";
import userReducer from "./userReducer";
import filterReducer from "./filterReducer";
import tileReducer from "./tileReducer";
import sourcesReducer from "./sourcesReducer";
import newsListReducer from "./newsListReducer";
import addPageReducer from "./setPageReducer";
import subscriptionReducer from "./subscriptionReducer";
import askQuestionReducer from "./askQuestionReducer";
import { getInitialUserToken } from "../actions/configActions";
import { composeWithDevTools } from "redux-devtools-extension";

import thunk from "redux-thunk";
import { persistReducer, persistStore } from "redux-persist";

const userPersistConfig = {
  key: "userPersist",
  storage,
};

const configPersistConfig = {
  key: "configPersist",
  storage,
};

const composedEnhancers = composeWithDevTools(applyMiddleware(thunk));

const rootReducer = combineReducers({
  configReducer: persistReducer(configPersistConfig, configReducer),
  topicReducer,
  userReducer: persistReducer(userPersistConfig, userReducer),
  filterReducer,
  tileReducer,
  sourcesReducer,
  newsListReducer,
  addPageReducer,
  subscriptionReducer,
  askQuestionReducer,
});

export const store = createStore(rootReducer, composedEnhancers);

export const persistor = persistStore(store);

export const actionsToBeExecutedOnTheStart = (store) => {
  store.dispatch(getInitialUserToken());
};
